export default "__VITE_ASSET__CrDHRrC0__"